export class DriverDeviationSelection {
  constructor(
    public conflictGroupId: string,
    public trainDriverId: string
  ) {}
}

export class ResolveDeviationRequest {
  constructor(
    public selections: DriverDeviationSelection[],
    public comment?: string
  ) {}
}
